export default __webpack_public_path__ + "static/media/1.94b3e9d9.png";